/**
 * When creating a new local storage variable, include the date in the beginning of the variable
 * e.g. `2021-07-15-reports-announcement-seen`
 * @see https://github.com/TheJumpCloud/jumpcloud-admin-portal/blob/master/docs/ui-dev-best-practices.md#include-dates-in-local-storage-variables
 */
export default {
  activityLogViewsAnnouncementDismissed: 'jcActivityLogViewsAnnouncementDismissed',
  adDistributionManagement: 'jcAdDistributionManagementDismissed',
  addLocalUserAccountModalAcknowledged: 'jcAddSystemUsernameModalAcknowledged',
  agentLogSavedData: 'jcAgentLogSavedData',
  androidEmmSurveyBannerDismissed: '2022-12-05-jcAndroidEmmSurveyBannerDismissed',
  announcementCardState: 'announcement-card-state',
  applicationInstructionsDismissed: 'jcApplicationInstructionsDismissed',
  applicationsIDTabsTransitionAcknowledged: 'jcApplicationsIDTabsTransitionAcknowledged',
  applicationsTabsTransitionAcknowledged: 'jcApplicationsTabsTransitionAcknowledged',
  authIdpPopoverDismissed: '2022-05-30-authIdpPopoverDismissed',
  authnpoliciesInstructionsSeen: 'jcAuthnpoliciesInstructionsSeen',
  authNPoliciesZeroStateGuidedSetupCollapsed: '2022-04-21-jcAuthNPoliciesZeroStateGuidedSetupCollapsed',
  bannerDismissed: 'jcBannerDismissed',
  bannerDismissedBenchmarkSurvey: '2022-08-08-jcBannerDismissedBenchmarkSurvey',
  bannerDismissedGlobalAdminSurvey: '2022-06-20-jcBannerDismissedGlobalAdminSurvey',
  bannerDismissedGlobalLegalTermsBanner: '2022-10-24-2022-10-31-jcBannerDismissedGlobalLegalTermsBanner',
  bannerDismissedPasswordManager: '2022-09-06-pwm-banner-dismissed',
  bannerDismissedUserGroupAutomatedMembers: '2022-10-26-bannerDismissedUserGroupAutomatedMembers',
  bannerDismissedUserGroupSudo: 'jcBannerDismissedUserGroupSudo',
  bannerDismissedFiresideChatBanner: '2022-05-23-jcBannerDismissedFiresideChatBanner',
  bannerDismissedNewlySelfServed: 'jcBannerDismissedNewlySelfServed',
  bannerDismissedUXRSurvey: '2023-03-13-jcBannerDismissedUXRSurvey',
  bannerDismissedDISurvey: '2022-06-27-jcBannerDismissedDISurvey',
  bindSystemToUserModalAcknowledged: 'jcBindSystemToUserModalAcknowledged',
  casePortalAnnouncementAcknowledged: '2022-11-04-casePortalAnnouncementAcknowledged',
  casePortalIntroModalSeen: '2022-11-10-casePortalIntroModalSeen',
  commandtemplateAnnouncementSeen: '2022-11-03-commandtemplateAnnouncementSeen',
  commandQueueItemsRowsPerPage: '2023-02-24-command-queue-items-per-page',
  columnsDevicePageAnnouncementAcknowledged: 'jcColumnsDevicePageAnnouncementAcknowledged',
  cloudInsightsAccountsRowsPerPage: 'jcCloudInsightsAccountsRowsPerPage',
  cloudInsightsEventsRowsPerPage: 'jcCloudInsightsEventsRowsPerPage',
  cloudInsightsEventsSelectedColumns: 'jcCloudInsightsEventsSelectedColumns',
  customEmailAnnouncementSeen: 'jcCustomEmailAnnouncementSeen',
  customerSelfServedTimestamp: 'jcCustomerSelfServedTimestamp',
  deviceInstructionsDismissed: 'jcDeviceInstructionsDismissed',
  devicesMainPanelLandingTab: 'jcDevicesMainPanelLandingTab',
  exportAnnouncementDeviceDismissed: 'jcExportAnnouncementDeviceDismissed',
  exportAnnouncementUserDismissed: 'jcExportAnnouncementUserDismissed',
  gettingStartedPopoverSeen: 'jcGettingStartedPopoverSeen',
  globalFallbackPolicyExpanded: 'jcGlobalFallbackPolicySettingExpanded',
  googleOrigin: 'jcLogin',
  groupsInstructionsDismissed: 'jcGroupsCollapsableDismissed',
  gsuiteInstructionsDismissed: 'jcGsuiteInstructionsDismissed',
  gsuiteDistributionManagement: 'jcGsuiteDistributionManagementDismissed',
  idmHrisBannerDismissed: '2022-09-14-jcIdmHrisBannerDismissed',
  idmPersonioBannerDismissed: '2022-05-10-jcIdmPersonioBannerDismissed',
  idmCustomRestOauthAppCatalogueDismissed: '2022-09-14-jcIdmCustomRestOauthAppCatalogueDismissed',
  importAdditionalGoogleAttributeDismissed: 'jcAdditionalGoogleAttributeDismissed',
  insightsInstructionsDismissed: 'jcInsightsInstructionsDismissed',
  instructionsCommandQueueDetailDismissed: 'jcInstructionsCommandQueueDetailDismissed',
  lastActiveTimeKey: 'lastActiveTime',
  locale: 'locale',
  loginModalSeen: 'jcLoginModalSeen',
  loginModalTesting: 'jcLoginModalTesting-2021-07-08',
  loginModalTestingSeen: 'jcLoginModalTestingSeen-2021-07-08',
  mdmBigSurReadiness: 'jcMdmBigSurReadiness',
  membershipFiltersEnabled: 'membershipFiltersEnabled',
  navPanelCollapsed: 'jcNavPanelCollapsed',
  navPanelSectionsCollapsed: 'jcNavPanelSectionsCollapsed',
  orgLogoUrl: 'jcLogoUrl',
  osManagementPopoverDismissed: 'jcOsManagementPopoverDismissed',
  o365InstructionsDismissed: 'jcO365InstructionsDismissed',
  passwordManagerAppVersionsRowsPerPage: '2022-09-22-passwordmanager-appversions-per-page',
  passwordManagerItemsRowsPerPage: '2022-11-01-passwordmanager-items-per-page',
  passwordManagerNudgeDismissed: 'jcPasswordManagerNudgeDismissed',
  passwordManagerUsersRowsPerPage: '2022-08-11-passwordmanagerusers-per-page',
  paymentPromptDismissed: 'jcPaymentPromptDismissed',
  paywallAbandonedNudgeVisible: 'jcPaywallAbandonedNudgeVisible',
  policyGroupTemplateAnnouncementSeen: '2023-01-20-policyGroupTemplateAnnouncementSeen',
  pwmUsersListRefreshAnnouncement: '2022-09-16-pwm-users-refresh-announcement',
  radiusInstructionsDismissed: 'jcRadiusInstructionsDismissed',
  recommendedApplicationsCarouselDismissed: 'jcRecommendedApplicationsCarouselDismissed',
  recommendedCommandQueueDismissed: 'jcRecommendedCommandQueueDismissed',
  recommendedCommandsCarouselDismissed: 'jcRecommendedCommandsCarouselDismissed',
  recommendedPoliciesCarouselDismissed: 'jcRecommendedPoliciesCarouselDismissed',
  recommendedPoliciesDismissed: 'jcRecommendedPoliciesDismissed',
  remoteWorkTipsPanelAnnouncementSeen: 'jcRemoteWorkTipsPanelAnnouncementSeen',
  reportsAnnouncementSeen: 'jcReportsAnnouncementSeen',
  reportsInstructionsDismissed: 'jcReportsInstructionsDismissed',
  resourcesPanelAnnouncementSeen: 'jcResourcesPanelAnnouncementSeen',
  sharedFolderGroupsRowsPerPage: '2023-01-31-sharedfoldergroups-per-page',
  sharedFoldersRowsPerPage: '2022-08-11-sharedfolders-per-page',
  sharedFolderSystemUsersRowsPerPage: '2022-08-11-sharedfoldersytemusers-per-page',
  ssoToApplicationsAnnouncementDismissed: '2023-01-04-jc-sso-to-apps-announcement-dismissed',
  supportCasesRowsPerPage: '2022-10-05-support-cases-rows-per-page',
  systemInstructionsDismissed: 'jcSystemInstructionsDismissed',
  systemMainPanelColumns: 'jcSystemMainPanelColumns',
  systemUserMainPanelColumns: 'jcSystemUserMainPanelColumns',
  universityModalSeen: 'jcUniversityModalSeen',
  upgradeLoginNudgeLastDismissed: 'jcupgradeLoginNudgeLastDismissed',
  userGroupDistributionEmail: 'jcUserGroupDistributionEmailDismissed',
  userScheduleStartDateTipDismissed: '2022-08-31-jcuserScheduleStartDateTipDismissed',
  userStateScheduleActivationBanner: '2022-07-07-jcUserStateScheduleActivationBannerDismissed',
  userStateManualBanner: '2022-08-15-jcUserStateManualBannerDismissed',
  uuid: 'jcUUID',
  vppAnnouncementPopoverDismissed: 'jcVppAnnouncementPopoverDismissed',
  welcomeHomeModalSeen: 'jcWelcomeHomeModalSeen',
  welcomeModalSeen: 'jcWelcomeModalSeen',
  windowsAppModalSeen: 'jcWindowsAppModalSeen',
};
